// extracted by mini-css-extract-plugin
export var clearIcon = "fT_mv";
export var input = "fT_kZ";
export var inputPrefixed = "fT_mK";
export var inputWrapper = "fT_k4";
export var invalid = "fT_mH";
export var large = "fT_bZ";
export var medium = "fT_b0";
export var prefix = "fT_mG";
export var xmedium = "fT_mJ";